type PowerBIEmbedProps = {
	value: {
		title: string;
		url: string;
	};
};

const iframeStyles = {
	aspectRatio: '16 / 9',
	border: 0,
	display: 'block',
	maxWidth: 'var(--line-length-max)',
	width: '100%',
} as const;

const PowerBIEmbed = ({ value }: PowerBIEmbedProps) => {
	if (!value?.url) {
		return null;
	}

	return (
		<iframe
			allowFullScreen={true}
			loading="lazy"
			src={value.url}
			style={iframeStyles}
			title={value.title || 'Power BI Embed'}
		/>
	);
};

export default PowerBIEmbed;
